import React from 'react';
import { TranslateText } from '@/helpers/utils/siteUtils';
import { DEFAULT_SITE_LANG } from '../../../../../../constants/constant';
import { PageTexts } from '../i18n';

type SearchType = {
  search: string | null;
  totalHits: number | null;
};
export const NumberOfProducts = ({ search, totalHits }: SearchType) => {
  const Texts = TranslateText(PageTexts, DEFAULT_SITE_LANG);
  return (
    <>
      {search && (
        <section className="text-2xl">
          {Texts.resultsFor} <strong className="text-black">&quot;{search}&quot;</strong>
          <br />
          <span className="text-sm">
            {totalHits} {Texts.items}
          </span>
        </section>
      )}
    </>
  );
};
